import { makeStyles } from "@mui/styles";
import { alpha } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    width: '100%',
    height: '100%'
  },

  box: {
    padding: '5px 0 9px',
    '&.noMargin': {
      '& > div': {
        marginBottom: 0,
      }
    }
  },

  actions: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    padding: '24px 36px',
    position: 'fixed',
    right: 0,
    bottom: 0,
    width: 456,
    borderTop: `1px solid ${alpha(theme.palette.secondary.main, 0.12)}`,
    '@media (max-width: 767px)': {
      width: '100%',
      padding: '16px 16px',
    }
  },
  actionsWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  },

  button: {
    width: '100%',
  },

  customScroll: {
    margin: '0 0 0 0',
    width: 'auto!important',
    '& .view': {
      margin: '0 -12px 0 0',
      paddingRight: '12px',
    },
    '& .track-vertical': {
      top: 5,
      bottom: 0,
      right: 0,
      borderRadius: '3px',
      width: '4px!important',
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity),
      '& > div': {
        position: 'relative',
        display: 'block',
        width: '100%',
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: `${alpha(theme.palette.secondary.light, 0.3)}!important`,
      }
    },
    '& .track-horizontal': {
      bottom: 2,
      left: 8,
      right: 8,
      height: '4px!important',
      borderRadius: '3px',
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity),
      '& > div': {
        position: 'relative',
        display: 'block',
        cursor: 'pointer',
        borderRadius: '3px!important',
        backgroundColor: `${alpha(theme.palette.secondary.light, 0.3)}!important`,
      }
    },
  },

  fieldWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  fieldWrapperPadding: {
    paddingLeft: 42,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  fieldFavorite: {
  },
  field: {
    flex: '1 1 auto'
  },
  fieldFull: {
    width: '100%',
  }
}));
